import { Button, Checkbox, Col, Form, Input, InputNumber, Radio, Row, Select, Space, Tabs } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import { LiaPercentSolid } from "react-icons/lia";


const shippingProviders = [
  {value: 'fixed_price', label: 'Fixed Price'},
  {value: 'based_on_rules', label: 'Based on Rules'}
];


const ShippingMethodChanges = () => {
  const [form] = Form.useForm();
  const params = useParams();
  const [incomingShipment, setIncomingShipment] = useState('');

  const onChangeIncomingShipment = (e) => setIncomingShipment(e.target.value);


  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/inventory/shipping-methods'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Shipping Methods</Link> / {params.action}
          </h3>
        </div>
        <Button htmlType='button' icon={<FaSave />}>Save</Button>
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='name'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Shipping Method Name"
        // value={formValue.name} 
        // onChangeIncomingShipment={onChangeIncomingShipmentName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={{}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col lg={{ span: 11 }}>
              <Form.Item label='Provider' name="provider" className='font-bold mb-2 column' required >
                <Select options={shippingProviders} />
              </Form.Item>
              <Form.Item label='Delivery Product' name="delivery_product" className='font-bold mb-2 column' required >
                <Select options={[]} />
              </Form.Item>
            </Col>
            <Col lg={{ span: 11, offset: 2 }}>
              <Form.Item labelCol={{span: 10,}} label='Margin On Rate' name="margin_on_rate" className='font-bold mb-2 column' required >
                <InputNumber addonAfter={<LiaPercentSolid />} className='w-full'/>
              </Form.Item>
              <Form.Item labelCol={{span: 9}} label='Free if order amount is above' className='font-bold column mb-2' required >
                <Space.Compact className='w-full'>
                  <Form.Item name={['free_condition', 'is_free']} noStyle valuePropName='checked'>
                    <Checkbox name='is_free' />
                  </Form.Item>
                  <Form.Item name={['free_condition', 'amount']} noStyle>
                    <InputNumber name='amount' className='w-full'/>
                  </Form.Item>
                </Space.Compact>
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            className='mt-4'
            type='card'
            items={[
              {
                key: 1,
                label: 'Pricing',
                children:
                  <>
                    <Form.Item labelCol={{span: 3}} label='Fixed Price' name="fixed_price" className='font-bold mb-2' required >
                      <InputNumber className='w-1/4'/>
                    </Form.Item>
                  </>
              },
              {
                key: 2,
                label: 'Destination Availability',
                children: 
                  <>
                    <Form.Item labelCol={{span: 3}} label='Region' name="region" className='font-bold mb-2' required >
                      <Select options={[]} style={{width: '300px'}}/>
                    </Form.Item>
                    <Form.Item labelCol={{span: 3}} label='City' name="city" className='font-bold mb-2' required >
                      <Select options={[]} style={{width: '300px'}}/>
                    </Form.Item>
                    <Form.Item labelCol={{span: 3}} label='Town' name="town" className='font-bold mb-2' required >
                      <Select options={[]} style={{width: '300px'}}/>
                    </Form.Item>
                  </>
              },
              {
                key: 3, 
                label: 'Description',
                children: 
                  <>
                    <Form.Item labelCol={{span: 3}} name="town" className='font-bold mb-2' required >
                      <Input type='text' placeholder='Descriptions are displayed on ecommerce and online quotations'/>
                    </Form.Item>
                  </>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default ShippingMethodChanges;